module.exports = __webpack_public_path__ + "static/img/dasada.10f9e8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dasada.jpg
// module id = glo9
// module chunks = 73